import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import classNames from 'classnames';
import { useRestaurant } from '../../contexts/restaurant.context';
import { showTab, tabs } from '../../store/actions/restaurant.actions';
import { hideSidebar, sidebars, toggleSidebar } from '../../store/actions/sidebar.actions';
import { pages, setPreviousHistory, showPage } from '../../store/actions/common.actions';
import {
    CART_ROUTE, CUSTOMER_ORDERS_ROUTE,
    CUSTOMER_ROUTE,
    HOME_ROUTE,
    LOGIN_ROUTE,
} from '../../router/constants';
import { useAuth } from '../../contexts/auth.context';
import AuthModal from './AuthModal';
import { getSearchParam, removeSearchParam, setSearchParam } from '../../utils/search-param';
import { CategoryListAndSearchItemButton } from '../../pages/restaurant/components/CategoryListAndSearchItemButton';

function Header({history}) {
    const [iconStyle, setIconStyle] = useState({});
    const [isShowLogin, setIsShowLogin] = useState(false);
    const [isShowUserMenu, setIsShowUserMenu] = useState(false);
    
    const userMenuRef = useRef(null);

    const { user, logout } = useAuth();
    
    const restaurant = useRestaurant();
   
    const dispatch = useDispatch();

    const cart = useSelector(state => state.cart.items);
    const activeSidebar = useSelector((state) => state.sidebar.active);
    // const isShowCartButton = useSelector(state => state.common.isShowCartButton);
    const page = useSelector(state => state.common.currentPage);

    const totalQuantity = cart.reduce((acc, item) => acc + item.quantity, 0);

    const isActiveSidebar = !!activeSidebar;
    const isShowCategorySearchButton = window.location.pathname === HOME_ROUTE; 

    const handlerToggleSidebar = (e, name) => {
        e.preventDefault();
        dispatch(toggleSidebar(name));
    };

    const handlerHideSidebar = (e) => {
        e.preventDefault();
        dispatch(hideSidebar());
    };

    const handlerShowTab = (e, name) => {
        e.preventDefault();
        dispatch(showTab(name));
    };

    const handlerGoToPage = (e, url, pageName) => {
        e.preventDefault();
        dispatch(setPreviousHistory(history.location.pathname, page));
        dispatch(showPage(pageName));
        history.push(url);
    };
    
    const handleLogout = async (e) => {
        e.preventDefault();

        await logout();
        
        window.location.replace(window.location.href);
    };
    
    const handleLogin = async (e) => {
        e.preventDefault();
        
        openLoginForm();
    };
    
    const openLoginForm = () => {
        setSearchParam('auth', true);
        setIsShowLogin(true);
    };
    
    const closeLoginForm = () => {
        removeSearchParam('auth');
        setIsShowLogin(false);
    };
    
    const handleCloseLoginModal = useCallback(() => closeLoginForm(), []);
    
    const handleToggleUserMenu = () => setIsShowUserMenu(prevState => !prevState);
    
    const handleUserMenuClick = (e) => {
        if (e.target.classList.contains('dropdown-item')) {
            setIsShowUserMenu(false);
        }
    }; 

    useEffect(() => {
        if (restaurant && restaurant.theme && restaurant.theme.restaurant_title_background_color.substr(0, 4).toUpperCase() !== '#FFF') {
            setIconStyle((prevState => {
                return {...prevState, color: '#FFFFFFFF'};
            }));
        }
        // else {
        //     setIconStyle({});
        // }
    }, [restaurant]);
    
    useEffect(() => {
        const auth = getSearchParam('auth');
        if (auth) {
            openLoginForm();
        }
        
        const handleOutsideClick = (e) => {
            if (!userMenuRef.current.contains(e.target)) {
                setIsShowUserMenu(false);
            }
        };

        window.addEventListener('click', handleOutsideClick);
        
        return () => {
            window.removeEventListener('click', handleOutsideClick);
        };
    }, []);

    if (!restaurant) {
        return null;
    }

    const { theme } = restaurant;

    return (
        <div id="stickyHeader" className="sticky">
            <AuthModal isOpen={isShowLogin} onClose={handleCloseLoginModal} />
            
            <header className="no-banner">
                <nav className="navbar navbar-expand-lg" style={{backgroundColor: theme.restaurant_title_background_color}}>
                    <div className={classNames('container-fluid', {'justify-content-start': isActiveSidebar, 'justify-content-between': !isActiveSidebar})}>
                        <div className={classNames('navbar-options', {'d-none': !isActiveSidebar})}>
                            <div className="d-flex align-items-center">
                                {/*<a className="btn btn-login mobile" data-toggle="modal" data-target="#registerModal" href="#">*/}
                                {/*    <i className="far fa-user"></i>Sign Up*/}
                                {/*</a>*/}
                                {/*<a className="btn mobile" data-toggle="modal" data-target="#languageModal" href="#">*/}
                                {/*    <i className="fas fa-language fa-lg"></i>*/}
                                {/*</a>*/}
                                <a className={classNames('btn btn-hide-cart', {'d-none': !isActiveSidebar})} href="#" onClick={handlerHideSidebar}>
                                    <i className="fas fa-angle-double-left fa-lg" style={{color: theme.restaurant_title_color ? theme.restaurant_title_color : '#fe0000'}}></i><span style={{paddingLeft: '10px', color: theme.restaurant_title_color ? theme.restaurant_title_color : '#fe0000'}}>Go Back</span>
                                </a>
                            </div>
                        </div>
                        <div
                            className={classNames('navbar-brand-wrap text-left', {
                                hidden: isActiveSidebar,
                                'd-none d-md-block': isShowCategorySearchButton,
                            })}
                        >
                            {restaurant.phone && (
                                <a className="navbar-brand" href={`tel:${restaurant.phone}`}>
                                    {'image' === theme.logo_type && theme.logo_url && (
                                        <img src={theme.logo_url} alt={restaurant.name} />
                                    )}
                                    {('restaurant_name' === theme.logo_type || theme.logo_url.length === 0) && (
                                        <span className="restaurant-title" style={{color: theme.restaurant_title_color ? theme.restaurant_title_color : '#fe0000'}}>{restaurant.name}</span>
                                    )}
                                    {'blank' === theme.logo_type && (
                                        <span></span>
                                    )}
                                </a>
                            )}
                            {!restaurant.phone && (
                                <a className="navbar-brand" href="#" onClick={(e) => handlerGoToPage(e, `${HOME_ROUTE}`, pages.restaurant)}>
                                    {'image' === theme.logo_type && theme.logo_url && (
                                        <img src={theme.logo_url} alt={restaurant.name} />
                                    )}
                                    {('restaurant_name' === theme.logo_type || theme.logo_url.length === 0) && (
                                        <span className="restaurant-title" style={{color: theme.restaurant_title_color ? theme.restaurant_title_color : '#fe0000'}}>{restaurant.name}</span>
                                    )}
                                    {'blank' === theme.logo_type && (
                                        <span></span>
                                    )}
                                </a>
                            )}
                        </div>

                        {isShowCategorySearchButton && (
                            <CategoryListAndSearchItemButton />
                        )}
                        
                        <div className={classNames('navbar-options', {hidden: isActiveSidebar})} style={{ gap: '0.5rem' }}>
                            {/*<a className="btn desktop" data-toggle="modal" data-target="#languageModal" href="#">*/}
                            {/*    <i className="fas fa-language fa-2x"></i>*/}
                            {/*</a>*/}
                            {/*<a href="https://www.ezordernow.com/partner/restaurants" className="btn btn-contact desktop"> Partner with Us</a>*/}
                            {/*<a className="btn btn-login desktop" data-toggle="modal" data-target="#registerModal" href="#">*/}
                            {/*    <i className="far fa-user"></i>Sign Up*/}
                            {/*</a>*/}
                            
                            {/*{isShowCartButton && (*/}
                            {/*    // <a href="#" className="btn btn-cart position-relative header-component__cart__padding d-block d-lg-none mr-2" onClick={(e) => {handlerToggleSidebar(e, Actions.sidebars.cart)}}>*/}
                            {/*    <a*/}
                            {/*        className="btn btn-cart position-relative header-component__cart__padding d-block d-xl-none mr-2"*/}
                            {/*        onClick={(e) => handlerGoToPage(e, CART_ROUTE, pages.cart)}*/}
                            {/*    >*/}
                            {/*        <div>*/}
                            {/*            <i className="fas fa-shopping-cart" style={{...iconStyle, fontsize: 1.5 + 'rem'}}></i>*/}
                            {/*            {cart.length > 0 && (*/}
                            {/*                <span className="cart-count header-component__cart__circle">{totalQuantity}</span>*/}
                            {/*            )}*/}
                            {/*        </div>*/}
                            {/*    </a>*/}
                            {/*)}*/}

                            <div
                                className="btn-group nav-user-menu"
                                ref={userMenuRef}
                            >
                                <button
                                    type="button"
                                    className="btn btn-danger dropdown-toggle"
                                    data-toggle="dropdown"
                                    aria-expanded="false"
                                    onClick={handleToggleUserMenu}
                                >
                                    <i className="fa-solid fa-user"></i>
                                </button>
                                
                                <div
                                    className={classNames('dropdown-menu dropdown-menu-right', {show: isShowUserMenu})}
                                    onClick={handleUserMenuClick}
                                >
                                    <a
                                        className="dropdown-item my-2 position-relative d-block d-md-none"
                                        onClick={(e) => handlerGoToPage(e, CART_ROUTE, pages.cart)}
                                    >
                                        <i className="fas fa-shopping-cart" style={{...iconStyle }}></i>
                                        Cart
                                        {cart.length > 0 && (
                                            <span
                                                className="badge badge-pill badge-danger position-absolute"
                                                style={{ right: '1.5rem' }}
                                            >
                                                    {totalQuantity}
                                                </span>
                                        )}
                                    </a>
                                    
                                    {/*<Link*/}
                                    {/*    to={SCHEDULE_ROUTE}*/}
                                    {/*    className="dropdown-item my-2 d-none d-md-block"*/}
                                    {/*>*/}
                                    {/*    <i className="far fa-clock" style={{...iconStyle}}></i>*/}
                                    {/*    Hours*/}
                                    {/*</Link>*/}
                                    
                                    {/*<a*/}
                                    {/*    className="dropdown-item my-2 d-block d-md-none"*/}
                                    {/*    onClick={(e) => {handlerToggleSidebar(e, sidebars.schedule)}}*/}
                                    {/*>*/}
                                    {/*    <i className="far fa-clock" style={{...iconStyle}}></i>*/}
                                    {/*    Schedule*/}
                                    {/*</a>*/}
                                    
                                    {!!user && (
                                        <>
                                            <Link
                                                to={CUSTOMER_ROUTE}
                                                className="dropdown-item my-2"
                                            >
                                                <i className="fas fa-user" style={{...iconStyle}}></i>
                                                Profile
                                            </Link>
                                            <Link
                                                to={CUSTOMER_ORDERS_ROUTE}
                                                className="dropdown-item my-2"
                                            >
                                                <i className="fas fa-clock-rotate-left" style={{...iconStyle}}></i>
                                                History
                                            </Link>
                                        </>
                                    )}
                                    
                                    <div className="dropdown-divider"></div>
                                    
                                    {!user && (
                                        <a
                                            href={LOGIN_ROUTE}
                                            className="dropdown-item my-2"
                                            onClick={handleLogin}
                                        >
                                            <i className="fas fa-key" style={{...iconStyle }}></i>
                                            Login
                                        </a>
                                    )}
                                    
                                    {!!user && (
                                        <a
                                            href="#"
                                            className="dropdown-item my-2"
                                            onClick={handleLogout}
                                        >
                                            <i className="fas fa-right-from-bracket" style={{...iconStyle }}></i>
                                            Logout
                                        </a>
                                    )}
                                    
                                    {/*<Link*/}
                                    {/*    to={REGISTRATION_ROUTE}*/}
                                    {/*    className="btn btn-text position-relative px-0 d-flex flex-column"*/}
                                    {/*>*/}
                                    {/*    <i className="fas fa-key" style={{...iconStyle, fontsize: '1.5rem'}}></i>*/}
                                    {/*    <span className="d-inline-block" style={{ fontSize: '1rem' }}>Sign Up</span>*/}
                                    {/*</Link>*/}
                                    
                                </div>
                            </div>
                            
                            {/*<a className="btn btn-search-trigger d-block d-md-none" href="#" onClick={(e) => {handlerToggleSidebar(e, Actions.sidebars.categories)}}>*/}
                            {/*    <i className="fas fa-bars"></i>*/}
                            {/*</a>*/}
                        </div>
                    </div>
                </nav>
            </header>
        </div>
    );
}

export default withRouter(Header);